import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_CONFIG } from '../../config';

interface Subcategory {
  id: string;
  name: string;
  categoryId: string;
  displayOrder: number;
}

interface CategoryWithSubcategories {
  id: string;
  name: string;
  displayOrder: number;
  subcategories: Subcategory[];
}

interface CategoriesResponse {
  data: CategoryWithSubcategories[];
}

export const storefrontCategoriesApi = createApi({
  reducerPath: 'storefrontCategoriesApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_CONFIG.API_URL }),
  tagTypes: ['StorefrontCategories'],
  // Retry failed requests and refetch on reconnect
  refetchOnMountOrArgChange: 30,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getStorefrontCategories: builder.query<CategoryWithSubcategories[], void>({
      query: () => '/categories?includeSubcategories=true',
      transformResponse: (response: any) => {
        
        
        // Handle the APIResponse wrapper structure
        let categories = [];
        if (response.result && response.result.data && Array.isArray(response.result.data)) {
          categories = response.result.data;
        } else if (response.data && Array.isArray(response.data)) {
          categories = response.data;
        } else if (Array.isArray(response)) {
          categories = response;
        }
        
        
        return categories
          .map((category: any) => ({
            ...category,
            subcategories: Array.isArray(category.subcategories) 
              ? category.subcategories.sort((a: any, b: any) => a.displayOrder - b.displayOrder)
              : [],
          }))
          .sort((a: any, b: any) => a.displayOrder - b.displayOrder);
      },
      providesTags: ['StorefrontCategories'],
      // Cache for 5 minutes (categories rarely change)
      keepUnusedDataFor: 300,
      // Retry failed requests
      extraOptions: { maxRetries: 2 },
    }),
  }),
});

export const { useGetStorefrontCategoriesQuery } = storefrontCategoriesApi;
